import { AxiosError } from 'axios';
import type { GetDocumentCollectionRequestType } from 'entities/document/api/types';
import { getDocument } from './get-document';

export type CollectionItem = {
  documentId: number;
  error?: Error;
  data?: ReturnType<typeof getDocument>;
};

/**
 * Synthetic request to get document collection
 * @param params
 */
export const getDocumentCollection = async (
  params: GetDocumentCollectionRequestType,
) =>
  Promise.all(
    params.documentIds.map(async documentId => {
      try {
        const data = await getDocument({
          documentId,
        });
        return {
          documentId,
          data,
        };
      } catch (error) {
        if (error instanceof AxiosError && error.status === 401) {
          throw error;
        }

        return {
          documentId,
          error,
        };
      }
    }),
  );
